<script setup lang="ts">
import { RouterView } from 'vue-router';
import NavBar from '@/components/common/NavBar.vue';
import NavBarAlt from '@/components/common/NavBarAlt.vue';
import { useAuthStore } from '@/stores/auth';
import { useReferenceDataStore } from '@/stores/referenceData';
import { useFeatureFlag } from '@/composables/useFeatureFlag';
import { onMounted } from 'vue';

const authStore = useAuthStore();
const referenceDataStore = useReferenceDataStore();
const navRedesignEnabled = useFeatureFlag('nav-redesign');

onMounted(async () => {
  await authStore.checkAuth();
  // Load reference data in the background — only when authenticated
  // (the /reference endpoint requires auth; calling it on guest pages causes 401 noise)
  if (authStore.isAuthenticated) {
    referenceDataStore.load();
  }
});
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <NavBarAlt v-if="navRedesignEnabled" />
    <NavBar v-else />
    <main class="flex-1">
      <RouterView />
    </main>
    <footer class="bg-sigmachi-blue text-white py-4 text-center text-sm">
      <p>&copy; {{ new Date().getFullYear() }} Eta Iota Chapter of Sigma Chi</p>
      <p class="text-gray-300 mt-1">Embry-Riddle Aeronautical University &middot; Daytona Beach, FL</p>
    </footer>
  </div>
</template>
